import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOpportunitySummary extends Layout {
    labelDetails: Label;
    labelOpportunity: Label;
    panelDetails: Panel;
    panelOpportunity: Panel;
    sourceOpportunitySummary: DataSource;
    textboxConfidenceValue: Textbox;
    textboxExpectedCloseDate: Textbox;
    textboxLastCompletedActivity: Textbox;
    textboxName: Textbox;
    textboxPotentialValue: Textbox;
}
